export const SET_STATUS = "SET_STATUS";

export function setStatus(step, form, status) {
  return {
    type: SET_STATUS,
    step,
    form,
    status,
  };
}
